<template>
  <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
    <path
      d="M0.012639 4.24465C0.012639 4.10894 0.0662651 3.97007 0.170405 3.86593C0.378687 3.65765 0.71953 3.65765 0.927812 3.86593L8.05997 10.9949L15.0848 3.97007C15.2931 3.76179 15.634 3.76179 15.8422 3.97007C16.0505 4.17835 16.0505 4.51918 15.8422 4.72746L8.43869 12.131C8.2304 12.3393 7.88958 12.3393 7.6813 12.131L0.170452 4.62332C0.0663118 4.51918 0.0126553 4.38033 0.0126553 4.24463L0.012639 4.24465Z"
      :class="containerClass"
    />
  </svg>
</template>

<script>
export default {
  props: {
    className: {
      type:  [String, Array],
      default: "",
    },
    containerClass: {
      type: String,
      default: "",
    },
  },
};
</script>
